import { FC } from 'react';

import { Bonus } from '../../../../../types/bonus';
import { AudioAttachmentPlayer } from '../../../../audio/player';

type AudioBonusAttachmentProps = {
	bonus: Bonus;
};

export const AudioBonusAttachment: FC<AudioBonusAttachmentProps> = ({ bonus }) => {
	const audioAttachment = bonus.attachments[0];

	if (!audioAttachment || audioAttachment.category !== 'audio') {
		return null;
	}

	return (
		<AudioAttachmentPlayer
			audioUrl={audioAttachment.audio_url || ''}
			quote={audioAttachment.audio_quote}
			giverName={bonus.giver.display_name}
			giverAvatarUrl={bonus.giver.profile_pic_url || bonus.giver.full_pic_url}
			duration={audioAttachment.audio_duration}
		/>
	);
};
